import styled from 'styled-components';
import { themes } from 'kb-shared';

export const FloatRightLink = styled.a`
  float: right;
  margin-left: 100px;
`;

export const Container = styled.div`
  ${({ theme }) => theme.grid.pageContainer};
  width: 100%;
  margin-top: 50px;

  @media screen and (max-width: ${themes.breakpoints.tabletLandscape}) {
    margin-top: 40px;
  }

  @media screen and (max-width: ${themes.breakpoints.tabletPortrait}) {
    margin-top: 100px;
  }

  @media screen and (max-width: ${themes.breakpoints.desktop}) {
    margin-top: 50px;
  }
`;

export const DashboardContent = styled.div`
  display: grid;
  grid-gap: 24px;
  row-gap: 36px;

  grid-template-columns: repeat(1, minmax(200px, 1fr));
  grid-template-rows: repeat(2, auto);

  @media screen and (min-width: ${themes.breakpoints.tabletPortrait}) {
    grid-template-columns: repeat(2, minmax(200px, 1fr));
    grid-template-rows: repeat(2, auto);
  }

  @media screen and (min-width: ${themes.breakpoints.smallDesktop}) {
    grid-template-columns: repeat(3, minmax(200px, 1fr));
    grid-template-rows: repeat(2, auto);
  }
`;
